import styled from "styled-components";

export const QuestionStyle = styled.div`
  background-color: white;
  max-height: 600px;
  overflow-y: auto;
  padding: 20px;

  & svg {
    color: rgb(6, 172, 56);
    margin-right: 7px;
  }
`;

export const Question = styled.div`
  font-weight: bold;
`;

export const Answer = styled.div`
  margin-top: 10px;
  font-size: 15px;
`;
export const QuestionContainer = styled.div`
  background-color: white;
  margin-bottom: 15px;
  box-shadow: 0px 0px 2px #9d9d9d;
  padding: 10px;
`;
